import styled from 'styled-components';
import IconArrowDown from './IconArrowDown';
var IconArrowLeft = /*#__PURE__*/styled(IconArrowDown).withConfig({
  displayName: "IconArrowLeft",
  componentId: "c11n-8-111-1__sc-mqj5dh-0"
})(["transform:rotate(90deg);"]);
export default IconArrowLeft;